import { Divider } from '@/components/ui/divider'
import { HStack } from '@/components/ui/hstack'
import { Icon } from '@/components/ui/icon'
import { Pressable } from '@/components/ui/pressable'
import { Text } from '@/components/ui/text'
import { VStack } from '@/components/ui/vstack'
import { trashedFormSelectors } from '@/redux/slices/trashedFormSlice'
import { useAppSelector } from '@/redux/store'
import dayjs from 'dayjs'
import { MoreVerticalIcon } from 'lucide-react-native'
import { Fragment } from 'react'

type TrashedFormItemProps = {
  token: string
  showBorder: boolean
  onPress: () => void
}

export default function TrashedFormItem({ token, showBorder, onPress }: TrashedFormItemProps) {
  const form = useAppSelector(state => trashedFormSelectors.selectById(state, token))

  if (!form) return null

  const descriptionItems = [`${dayjs(form.deletedAt).format('YYYY-MM-DD HH:mm')} 删除`, `${form.entryCount} 条数据`]

  return (
    <Pressable onPress={onPress} className="data-[active=true]:bg-background-100">
      <HStack className={`px-6 items-center ${showBorder ? 'border-b border-background-100' : ''}`}>
        <VStack space="sm" className="flex-1 justify-center py-4">
          <Text size="body" className="text-label">
            {form.subname || form.name}
          </Text>
          {descriptionItems.length > 0 && (
            <HStack space="sm" className="items-center">
              {descriptionItems.map((desc, index) => (
                <Fragment key={index}>
                  {index > 0 && <Divider orientation="vertical" className="h-3/5" />}
                  <Text size="subhead" className="text-secondary-label">
                    {desc}
                  </Text>
                </Fragment>
              ))}
            </HStack>
          )}
        </VStack>
        <Icon as={MoreVerticalIcon} className="text-secondary-label" />
      </HStack>
    </Pressable>
  )
}
